
<!-- Loader -->
<div class="loader-overlay" *ngIf="loading">
  <div class="loader">
    <div class="loader__bar"></div>
    <div class="loader__bar"></div>
    <div class="loader__bar"></div>
    <div class="loader__bar"></div>
    <div class="loader__bar"></div>
    <div class="loader__ball"></div>
  </div>
</div>

<div class="modal-inner">
  <button class="close-btn" (click)="onCancel()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>

  <!-- Stepper -->
  <div class="stepper">
    <div class="step" [class.active]="currentStep === 1" [class.done]="currentStep > 1">
      <div class="step-circle">
        <mat-icon *ngIf="currentStep > 1">check</mat-icon>
        <span *ngIf="currentStep <= 1">1</span>
      </div>
      <div class="step-label">Current password</div>
    </div>
    <div class="step-line" [class.done]="currentStep > 1"></div>

    <div class="step" [class.active]="currentStep === 2" [class.done]="currentStep > 2">
      <div class="step-circle">
        <mat-icon *ngIf="currentStep > 2">check</mat-icon>
        <span *ngIf="currentStep <= 2">2</span>
      </div>
      <div class="step-label">New password</div>
    </div>
    <div class="step-line" [class.done]="currentStep > 2"></div>

    <div class="step" [class.active]="currentStep === 3" [class.done]="currentStep > 3">
      <div class="step-circle">
        <mat-icon *ngIf="currentStep > 3">check</mat-icon>
        <span *ngIf="currentStep <= 3">3</span>
      </div>
      <div class="step-label">Verify OTP</div>
    </div>
    <div class="step-line" [class.done]="currentStep > 3"></div>

    <div class="step" [class.active]="currentStep === 4" [class.done]="currentStep >= 4">
  <div class="step-circle">
    <mat-icon *ngIf="currentStep >= 4">check</mat-icon>
    <span *ngIf="currentStep < 4">4</span>
  </div>
  <div class="step-label">Done</div>
</div>
  </div>

  <!-- Step 1: Current password -->
  <div class="panel" *ngIf="currentStep === 1">
    <h3 class="title">Password</h3>
    <p class="subtitle">Enter your current password to continue.</p>

    <label class="field-label">Current password</label>
    <div class="input-wrap">
   <input
  [type]="currentPasswordVisible ? 'text' : 'password'"
  [(ngModel)]="currentPassword"
  placeholder="Enter current password"
  autocomplete="new-password"
  name="currentPasswordField"
  [class.error]="currentPasswordError" />
      <button type="button" class="eye-toggle" (click)="toggleVisibility('current')">
        <mat-icon>{{ currentPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </div>
    <div class="error-text" *ngIf="currentPasswordError">{{ currentPasswordError }}</div>

    <div class="row-actions">
      <button class="primary-btn" (click)="onContinue()">Continue</button>
    </div>
  </div>

  <!-- Step 2: New password -->
  <div class="panel" *ngIf="currentStep === 2">
    <h3 class="title">Create a new password</h3>
    <p class="subtitle">Choose a strong password you haven't used before.</p>

    <label class="field-label">New password</label>
    <div class="input-wrap">
  <input
    [type]="newPasswordVisible ? 'text' : 'password'"
    [(ngModel)]="newPassword"
    (ngModelChange)="checkRules()"
    placeholder="Enter new password"
    autocomplete="new-password" />

  <button type="button" class="eye-toggle" (click)="toggleVisibility('new')">
    <mat-icon>{{ newPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
  </button>
</div>

<div class="error-text" *ngIf="passwordLengthError">
  {{ passwordLengthError }}
</div>
<div class="error-text" *ngIf="newPasswordError">
  {{ newPasswordError }}
</div>
    <ul class="req-list">
    
     <li [class.met]="rules.len">
  <span class="dot">
    <mat-icon *ngIf="rules.len">check</mat-icon>
  </span>
  Minimum {{ passwordLength }} characters
</li>

<li *ngIf="passwordPolicy.requireUppercase" [class.met]="rules.upper">
  <span class="dot">
    <mat-icon *ngIf="rules.upper">check</mat-icon>
  </span>
  One uppercase letter
</li>

<li *ngIf="passwordPolicy.requireLowercase" [class.met]="rules.lower">
  <span class="dot">
    <mat-icon *ngIf="rules.lower">check</mat-icon>
  </span>
  One lowercase letter
</li>

<li *ngIf="passwordPolicy.requireNumber" [class.met]="rules.num">
  <span class="dot">
    <mat-icon *ngIf="rules.num">check</mat-icon>
  </span>
  One number
</li>

<li *ngIf="passwordPolicy.requireSpecialCharacter" [class.met]="rules.special">
  <span class="dot">
    <mat-icon *ngIf="rules.special">check</mat-icon>
  </span>
  One special character
</li>
    </ul>

    <label class="field-label">Confirm password</label>
    <div class="input-wrap">
        <input
  id="confirmPasswordField"
  [type]="newPasswordVisible ? 'text' : 'password'"
  [(ngModel)]="confirmPassword"
  (ngModelChange)="validateConfirm()"
  placeholder="Re-enter new password"
  autocomplete="new-password"
  name="confirmPasswordField"
  required
  [class.error]="confirmPasswordError" />
<!-- no second eye icon here — shares state with the New password field above -->
    </div>
    <div class="error-text" *ngIf="confirmPasswordError">{{ confirmPasswordError }}</div>

    <div class="row-actionss">
      <button class="link-btn" (click)="onBack()">Back</button>
      <button class="primary-btn" [disabled]="!canSendOtp" (click)="onSendOtp()">Send OTP</button>
    </div>
  </div>

  <!-- Step 3: Verify OTP -->
  <div class="panel" *ngIf="currentStep === 3">
    <h3 class="title">Enter verification code</h3>
    <p class="subtitle">We sent a 6-digit code to <strong>{{ maskedEmail }}</strong> to confirm this change.</p>
<div class="otp-boxes">
  <input
    #otp0
    class="otp-box"
    maxlength="1"
    inputmode="numeric"
    pattern="[0-9]*"
    (input)="onOtpInput($event, 0, otp1)"
    (keydown)="moveToPrev($event, null)" />

  <input
    #otp1
    class="otp-box"
    maxlength="1"
    inputmode="numeric"
    pattern="[0-9]*"
    (input)="onOtpInput($event, 1, otp2)"
    (keydown)="moveToPrev($event, otp0)" />

  <input
    #otp2
    class="otp-box"
    maxlength="1"
    inputmode="numeric"
    pattern="[0-9]*"
    (input)="onOtpInput($event, 2, otp3)"
    (keydown)="moveToPrev($event, otp1)" />

  <input
    #otp3
    class="otp-box"
    maxlength="1"
    inputmode="numeric"
    pattern="[0-9]*"
    (input)="onOtpInput($event, 3, otp4)"
    (keydown)="moveToPrev($event, otp2)" />

  <input
    #otp4
    class="otp-box"
    maxlength="1"
    inputmode="numeric"
    pattern="[0-9]*"
    (input)="onOtpInput($event, 4, otp5)"
    (keydown)="moveToPrev($event, otp3)" />

  <input
    #otp5
    class="otp-box"
    maxlength="1"
    inputmode="numeric"
    pattern="[0-9]*"
    (input)="onOtpInput($event, 5, null)"
    (keydown)="moveToPrev($event, otp4)" />
</div>
    <div class="error-text" *ngIf="otpError">{{ otpError }}</div>

    <div class="resend-row">
      <span
        class="link-btn"
        [class.disabled]="resendSecondsLeft > 0"
        (click)="onResendOtp()">Resend OTP</span>
      <ng-container *ngIf="resendSecondsLeft > 0"> in {{ resendTimerLabel }}</ng-container>
    </div>

    <div class="row-actionss">
      <button class="link-btn" (click)="onBack()">Back</button>
      <button class="primary-btn" (click)="onVerifyOtp()">Verify OTP</button>
    </div>
  </div>

  <!-- Step 4: Done -->
  <!-- Step 4: Password Updated -->
<div class="panel" *ngIf="currentStep === 4">
  <div class="done-wrap">
    <div class="done-check">
      <mat-icon>check</mat-icon>
    </div>

    <h3>Password updated</h3>

    <p>
      Your password has been updated successfully.<br />
      Redirecting to the sign-in page to authenticate.
    </p>

    <div class="redirecting">
      <span class="spinner"></span>
      <span>Redirecting...</span>
    </div>
  </div>
</div>

</div>